import { Link } from 'react-router-dom';
import { Plane, Calendar, Scale, Wallet, Check, Arrow } from '../Icons';

export default function Travellers() {
  return (
    <section className="section section--tint" id="travellers">
      <div className="container split">
        <div className="split__visual reveal">
          <div className="trip-card">
            <div className="trip-card__top">
              <span className="chip"><Plane width={14} height={14} /> Flight</span>
              <span className="chip chip--green">Listed</span>
            </div>
            <div className="trip-card__route">
              <div>
                <small>From</small>
                <strong>DEL</strong>
                <span>New Delhi</span>
              </div>
              <div className="trip-card__line"><Plane width={18} height={18} /></div>
              <div className="ta-right">
                <small>To</small>
                <strong>LHR</strong>
                <span>London</span>
              </div>
            </div>
            <div className="trip-card__meta">
              <div><Calendar width={16} height={16} /> 22 Oct 2026</div>
              <div><Scale width={16} height={16} /> 10 kg spare</div>
            </div>
            <div className="capacity">
              <div className="capacity__label"><span>Capacity assigned</span><span>6 / 10 kg</span></div>
              <div className="capacity__bar"><i style={{ width: '60%' }} /></div>
            </div>
            <div className="trip-card__earn">
              <Wallet width={18} height={18} />
              <span>2 items assigned by admin. Earnings credited after delivery.</span>
            </div>
          </div>
        </div>

        <div className="split__copy reveal" style={{ '--delay': '100ms' }}>
          <span className="kicker">For travellers</span>
          <h2>Your spare luggage space is worth something</h2>
          <p>
            Already going somewhere? List your trip, set the capacity you are happy to share, and let our
            team bring you verified, pre-paid items. No chasing, no negotiating.
          </p>
          <ul className="checklist">
            <li><Check width={18} height={18} /> List trips by flight, train, bus or car</li>
            <li><Check width={18} height={18} /> You control capacity and what you carry</li>
            <li><Check width={18} height={18} /> Your contact details stay private from browsing senders</li>
            <li><Check width={18} height={18} /> Only admin-approved, screened items reach you</li>
          </ul>
          <Link to="/register?role=traveller" className="btn btn--primary btn--lg">
            Register your journey <Arrow width={18} height={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
